import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/en';
import 'dayjs/locale/tr';

dayjs.extend(customParseFormat);

export const parseLocalizedDate = (
  dateStr: string,
  locale: 'tr' | 'en',
  format: string = 'D MMMM YYYY'
) => {
  dayjs.locale(locale);
  return dayjs(dateStr, format);
};

export const formatLocalizedDate = (
  isoDate: string,
  locale: 'tr' | 'en',
  format: string = 'D MMMM YYYY'
) => {
  dayjs.locale(locale);
  return dayjs(isoDate).format(format);
};
